import React from 'react';

import './PricingCard.css';

// Define types for feature items
type FeatureWithHighlight = {
  text: string;
  highlight?: string;
};

// Type for features that can be either string or object with highlight
type Feature = string | FeatureWithHighlight;

// Props interface for the PricingCard component
interface PricingCardProps {
  title: string;
  description: string;
  price: string | number | undefined;
  period?: string | null;
  features: Feature[];
  buttonText: string;
  buttonVariant?: 'primary' | 'outline';
  isPopular?: boolean;
}

const PricingCard: React.FC<PricingCardProps> = ({
  title,
  description,
  price,
  period,
  features,
  buttonText,
  buttonVariant = 'outline',
  isPopular = false,
}) => {
  return (
    <div className="pricing-card">
      {isPopular && <div className="popular-badge">Popular</div>}

      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        <p className="card-description">{description}</p>
      </div>

      <div className="card-price">
        <div className="price">
          {typeof price === 'number' ? (
            <>
              <span>$</span>
              {price}
            </>
          ) : (
            <span>{price}</span>
          )}
        </div>
        {period && <div className="price-period">{period}</div>}
      </div>

      <div className="card-features">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 12L10 17L20 7"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>
              {typeof feature === 'object' ? feature.text : feature}
              {typeof feature === 'object' && feature.highlight && (
                <span className="feature-highlight">{feature.highlight}</span>
              )}
            </span>
          </div>
        ))}
      </div>

      <div className="card-action">
        <a href="#" className={`btn ${buttonVariant === 'primary' ? 'btn-primary' : 'btn-outline'}`}>
          {buttonText}
        </a>
      </div>
    </div>
  );
};

export default PricingCard;
